import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type FontScale = 0 | 1 | 2 | 3

interface AccessibilityState {
  fontScale: FontScale
  boldText: boolean
  setFontScale: (scale: FontScale) => void
  setBoldText: (bold: boolean) => void
  reset: () => void
}

export const useAccessibility = create<AccessibilityState>()(
  persist(
    (set) => ({
      fontScale: 0,
      boldText: false,
      setFontScale: (fontScale) => set({ fontScale }),
      setBoldText: (boldText) => set({ boldText }),
      reset: () => set({ fontScale: 0, boldText: false }),
    }),
    { name: 'accessibility:v1', version: 1 },
  ),
)

export const SCALE_LABELS = ['Default', 'Medium', 'Large', 'XL', 'XX'] as const
export const SCALE_PERCENTS = ['100%', '115%', '130%', '150%', '200%'] as const
export const SCALE_VALUES = [1, 1.15, 1.3, 1.5, 2] as const

export const TITLE_SIZES = [
  'text-[16px] leading-[22px]',
  'text-[18px] leading-[25px]',
  'text-[21px] leading-[28px]',
  'text-[24px] leading-[32px]',
  'text-[32px] leading-[40px]',
] as const

export const DESC_SIZES = [
  'text-[14px] leading-[20px]',
  'text-[16px] leading-[22px]',
  'text-[18px] leading-[25px]',
  'text-[21px] leading-[28px]',
  'text-[28px] leading-[36px]',
] as const

export const META_SIZES = [
  'text-[12px]',
  'text-[14px]',
  'text-[16px]',
  'text-[18px]',
  'text-[24px]',
] as const
